import { useState } from 'react';
import Script from 'next/script';
import { Schema } from './PandectesWithdrawal.schema';

export function PandectesWithdrawal({ cms }) {
  const { localeCode = 'en', lang = 'en' } = cms;

  // The withdrawal module reads config defined by the settings script, so it
  // must only load once the settings script has executed.
  const [settingsLoaded, setSettingsLoaded] = useState(false);

  return (
    <div className="px-contained py-contained">
      {/* Pandectes withdrawal settings */}
      <Script
        id="pandectes-withdrawal-settings"
        src="https://st.pandect.es/clearly-filtered/pandectes-withdrawal-settings.js"
        strategy="afterInteractive"
        onLoad={() => setSettingsLoaded(true)}
      />

      {/* Pandectes withdrawal script */}
      {settingsLoaded && (
        <Script
          id="pandectes-withdrawal-script"
          type="module"
          src="https://s.pandect.es/scripts/latest/pandectes-withdrawal.js"
          strategy="afterInteractive"
        />
      )}

      {/* Pandectes withdrawal component */}
      {/* data-locale: two-letter locale code. Required. */}
      {/* lang: language code. Required. */}
      <pandectes-withdrawal data-locale={localeCode} lang={lang} />
    </div>
  );
}

PandectesWithdrawal.displayName = 'PandectesWithdrawal';
PandectesWithdrawal.Schema = Schema;
